import { render, staticRenderFns } from "./ListOfArtists.vue?vue&type=template&id=c878eb5c&scoped=true"
import script from "./ListOfArtists.vue?vue&type=script&lang=js"
export * from "./ListOfArtists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c878eb5c",
  null
  
)

export default component.exports